<template lang="pug">
    .abandoned-cart-handler
        template(v-if="isLoading")
            re-loading(:loadingMessage="loadingMessage")
        p.text-center.m-b-60(v-if="isFailed") Your order has already been completed. 
            a(href="#" @click.prevent="gotoCart") Start a new booking.
</template>

<script>
import CartMixin from 'utils/vue/mixins/cart'
import ReLoading from 'utils/vue/components/elements/re-loading'

const EventBus = window.VueEventBus

export default {
    name: 'abandoned-cart-handler',

    mixins: [
        CartMixin,
    ],

    components: {
        ReLoading
    },

    props: {
      // Whether to open product edit page when an invalid cart item is found
      editOnInvalid: {
          type: Boolean,
          default: false
      }
    },

    data: () => ({
        isLoading: false,
        isFailed: false,
        loadingMessage: ''
    }),

    async mounted() {
        const cart = await this.loadCart()

        if (cart) {
            if (this.editOnInvalid) {
                await this.takeAction()
            } else {
                this.isLoading = true
                this.loadingMessage = 'Loading cart'
                this.gotoCart()
            }
        } else {
            this.isFailed = true
        }
    },

    methods: {
        async loadCart() {
            let cart
            this.isLoading = true
            this.loadingMessage = 'Loading cart'

            const url = new URL(window.location.href)
            const query = Object.fromEntries(url.searchParams.entries())
            const id = query.order_id
            try {
                cart = await this.restoreIncompleteOrder({ id })
            } catch (e) {
                debugLog("Unable to load cart", [e])
                cart = null
            } finally {
                this.isLoading = false
                this.loadingMessage = 'Loading cart'
            }

            return cart
        },

        async takeAction() {
            let firstInvalidItem = null

            EventBus.$on('cart.error.item.validation', (itemError, cartItem) => {
                if (!firstInvalidItem) {
                    firstInvalidItem = cartItem
                }
            })

            try {
                this.isLoading = true
                this.loadingMessage = 'Validating'
                await this.validateCart()
            } finally {
                if (firstInvalidItem) {
                    this.cartItemOnEdit({ item: firstInvalidItem })
                } else {
                    this.gotoCart()
              }
            }
        },

        gotoCart() {
          this.$router.push({ name: 'cart' })
        },
    }
}
</script>
